import React, { useState } from "react";
import Header from "../layout/header";
import jwt_decode from "jwt-decode";
import Confetti from "react-confetti";
import "../components/common/index.scss";
import Footer from "../components/global/FooterComponent";
import feedbackTitle from "../assets/img/bg/feeback_title.png";
import feedbacknew from "../assets/img/bg/feedbacknew.jpeg"
import feedback01 from "../assets/img/icons/feedback_01.png";
import feedback02 from "../assets/img/icons/feedback_02.png";
import feedback03 from "../assets/img/icons/feedback_03.png";
import feedback04 from "../assets/img/icons/feedback_04.png";
import feedback05 from "../assets/img/icons/feedback_05.png";
import feedbackBar from "../assets/img/bg/feedback_bar.png";
import feedbackMudraKosh from "../assets/img/icons/mudrakosh.png";
import bgBorder from "../assets/img/bg/border.svg";
import kalashIcon from "../assets/img/icons/kalash.png";
import email48 from "../assets/img/icons/icons-gmail.png";
import whatsapp48 from "../assets/img/icons/whatsapp-48.png";
import twitter48 from "../assets/img/icons/twitter-48.png";
import successCheck from "../svg/successCheck.svg";
import iIcon from "../svg/iIcon.svg";
import { feedbackTextValues } from "../constants";
import {
  getProfileDetails,
  submitFeedback,
} from "../store/apiCalls/profileDetails";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import {
  FetchProfileDetails,
} from "../containers/autherFlow/personalDetails/queries";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import copy from "copy-to-clipboard";
import { isMobile } from "react-device-detect";
import {
  EmailShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import { SERVER_URL } from "../config";
import Button from "../components/common/Button";

const initialState = {
  showFeedbackModal: false,
  skipModal: false,
  congratsModal: false,
  referModal: false,
  congratsPreview: false,
  isSkipped: false,
};

const ThanksForRegistration = ({ handleModalClose = () => { } }) => {
  const [feedbackScore, setFeedbackScore] = useState(null);
  const [feedbackValue, setFeedback] = useState("");
  const [modalState, setModalState] = useState(initialState);
  const [mobileAlert, setMobileAlert] = useState(false);
  const [referralCode, setReferralCode] = useState("");
  const { user, userLoginDetails } = useSelector(
    (state) => state?.LoginReducer
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = localStorage.usertoken
    ? jwt_decode(localStorage.usertoken)
    : "";
  const headers = { Authorization: `Bearer ${localStorage.usertoken || ""}` };

  const handleFeedback = (e) => {
    setFeedbackScore(e.target.value);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const queryParams = {
      params: { id: id },
      data: {
        userId: id,
        rating: parseInt(feedbackScore),
        feedbackText: feedbackValue,
        feedback: true,
      },
      headers,
    };

    const resPayload = await submitFeedback(queryParams);
    console.log(resPayload);
    if (resPayload.data.success) {
      setModalState({ ...modalState, congratsModal: true });
      refetch();
    } else {
      toast.error(resPayload.data.error);
    }
  };

  const handleFeedbackModalStat = async () => {
    setModalState({ ...modalState, congratsModal: false });
  };

  const publishSuccessHandler = (_success) => {
    if (_success?.data?.success) {
      setModalState({
        ...modalState,
        congratsModal: false,
        congratsPreview: true,
      });
    } else {
      toast.error(_success?.data?.error);
      setModalState(initialState);
    }
    dispatch({
      type: "SET_LOADER",
      payload: false,
    });
  };


  const handleCongratsModalClose = (publish = false) => {
    if (publish) {
      setModalState({
        ...modalState,
        congratsPreview: true,
        congratsModal: false,
      });
    } else {
      setModalState({ ...modalState, referModal: true, congratsModal: false });
    }
  };

  const handleSkipModalOpen = (e) => {
    e.preventDefault();
    setModalState({
      ...modalState,
      skipModal: true,
    });
  };

  const handleSkipModalClose = (isSkip = false) => {
    if (isSkip) {
      setModalState({
        ...modalState,
        skipModal: false,
        congratsModal: true,
        isSkipped: true,
      });
    } else {
      setModalState({
        ...modalState,
        skipModal: false,
      });
    }
  };

  const handleRedirectDashboard = (e, path = "/registration") => {
    e.preventDefault();
    window.scroll({ top: 0, behavior: "smooth" });
    navigate(path);
  };

  const handleCongratsPreviewModalClose = () => {
    setModalState(initialState);
  };

  const handleRedirect = (e, path = "/") => {
    e.preventDefault();
    window.scroll({ top: 0, behavior: "smooth" });
    navigate(path);
  };

  const fetchdata = async () => {
    const params = { id: user?._id };
    const headers = { Authorization: `Bearer ${userLoginDetails?.token}` };
    return getProfileDetails(headers, params);
  };

  const sucessHandler = (fetchedData) => {
    let resData = fetchedData?.data?.data;
    const code = resData?.promoCode || "XXXXXXX";
    setReferralCode(code);
  };

  const { refetch } = FetchProfileDetails(fetchdata, sucessHandler);

  const handleCodeCopy = (e) => {
    copy(code);
    e.target.textContent = "Copied";
    e.target.style.setProperty("color", "#404040");
  };

  const handleReferModalClose = (publish = false) => {
    if (publish) {
      setModalState({ ...modalState, referModal: false, congratsPreview: true });
    } else {
      setModalState(initialState);
    }
  };

  const shareUrl = SERVER_URL;
  const title = `I have just signed up as a researcher with Vikramshila Education. It is an Indian Open Access Platform for Research Publishing. I really liked their mission to create multiple digital platforms to help disseminate research, primarily from the developing world. I would like you to be a part of this movement. 
    
    Use the referral code ${referralCode} to register on the "https://vikramshilaedu.in/" and be a part of the largest database of research professionals. You will earn 250 mudras as welcome bonus (INR 250), which you can use to publish your own research paper. 
    
    "https://vikramshilaedu.in/registration"`;

  return (
    <>
      <Header />

      <div
        style={{
          minHeight: "100vh",
          background: "#f4f6fb",
          paddingTop: "200px",
          paddingBottom: "48px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {/* ── 3-STEP STEPPER — ALL DONE ── */}
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
            marginBottom: "28px",
            position: "relative",
            maxWidth: "400px",
            width: "100%",
          }}
        >
          {/* Step 1 */}
          {[
            {
              label: "Personal",
              icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ width: 18, height: 18 }}>
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
              ),
            },
            {
              label: "Professional",
              icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ width: 18, height: 18 }}>
                  <rect x="2" y="7" width="20" height="14" rx="2" />
                  <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
                </svg>
              ),
            },
            {
              label: "Finished",
              icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ width: 18, height: 18 }}>
                  <path d="M9 12l2 2 4-4" />
                  <path d="M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0z" />
                </svg>
              ),
            },
          ].map((step, i, arr) => (
            <div
              key={i}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                position: "relative",
                flex: 1,
                maxWidth: 140,
              }}
            >
              {/* connector line */}
              {i < arr.length - 1 && (
                <div
                  style={{
                    position: "absolute",
                    top: 20,
                    left: "calc(50% + 22px)",
                    width: "calc(100% - 44px)",
                    height: 2,
                    background: "#006f92",
                    zIndex: 0,
                  }}
                />
              )}
              <div
                style={{
                  width: 42,
                  height: 42,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "2px solid #006f92",
                  background: "#006f92",
                  color: "#fff",
                  zIndex: 1,
                  position: "relative",
                  boxShadow: "0 0 0 4px rgba(0,111,146,0.15)",
                }}
              >
                {step.icon}
              </div>
              <span
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: 12,
                  fontWeight: 700,
                  color: "#006f92",
                  marginTop: 8,
                  textAlign: "center",
                  whiteSpace: "nowrap",
                }}
              >
                {step.label}
              </span>
            </div>
          ))}
        </div>

        {/* ── CARD ── */}
        <div
          style={{
            background: "#fff",
            borderRadius: 16,
            boxShadow: "0 4px 32px rgba(0,111,146,0.08)",
            padding: "36px 40px 32px",
            width: "100%",
            maxWidth: 560,
          }}
        >
          {/* Header */}
          <div style={{ textAlign: "center", marginBottom: 24 }}>
            <h1
              style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: "1.6rem",
                fontWeight: 700,
                color: "#101828",
                marginBottom: 4,
              }}
            >
              Thank You for Registering! 🎉
            </h1>
            <p
              style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: 15,
                color: "#ff8300",
                fontWeight: 600,
                marginBottom: 0,
              }}
            >
              Your feedback will help us improve your experience.
            </p>
          </div>

          {/* Feedback Form */}
          <form onSubmit={(e) => handleFormSubmit(e)}>
            <div style={{ textAlign: "center", marginBottom: 8 }}>
              <b
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: 15,
                  color: "#344054",
                }}
              >
                Submit feedback and earn{" "}
                <span style={{ color: "#006f92" }}>500 Mudras</span> (INR)
              </b>
            </div>

            {/* Smiley Rating */}
            <div style={{ marginBottom: 16 }}>
              <div style={{ textAlign: "center", marginBottom: 8 }}>
                <img
                  src={feedbackTitle}
                  alt="rating scale"
                  style={{ maxWidth: "100%", height: "auto" }}
                />
              </div>
              <ul
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 12,
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                }}
              >
                {[feedback01, feedback02, feedback03, feedback04, feedback05].map(
                  (src, idx) => (
                    <li key={idx}>
                      <label
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <input
                          value={idx + 1}
                          type="radio"
                          name="rating"
                          required
                          onChange={handleFeedback}
                          style={{ display: "none" }}
                        />
                        <img
                          src={src}
                          alt={`rating-${idx + 1}`}
                          style={{
                            width: 48,
                            height: 48,
                            opacity: feedbackScore == idx + 1 ? 1 : 0.5,
                            transform: feedbackScore == idx + 1 ? "scale(1.2)" : "scale(1)",
                            transition: "all 0.2s ease",
                          }}
                        />
                      </label>
                    </li>
                  )
                )}
              </ul>
              <div style={{ textAlign: "center", marginTop: 6 }}>
                <img
                  src={feedbackBar}
                  alt="bar"
                  style={{ maxWidth: "90%", height: "auto" }}
                />
              </div>
            </div>

            {/* Feedback label */}
            {feedbackScore && (
              <div style={{ marginBottom: 8, textAlign: "center" }}>
                <label
                  style={{
                    fontFamily: "'Inter', sans-serif",
                    fontSize: 14,
                    color: "#009b94",
                    fontWeight: 600,
                  }}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: feedbackTextValues[feedbackScore],
                    }}
                  />
                </label>
              </div>
            )}

            {/* Textarea */}
            {feedbackScore && (
              <div style={{ marginBottom: 20 }}>
                <textarea
                  onChange={(e) => setFeedback(e.target.value)}
                  style={{
                    width: "100%",
                    minHeight: 100,
                    borderRadius: 10,
                    border: "1.5px solid #d0d5dd",
                    padding: "12px 14px",
                    fontFamily: "'Inter', sans-serif",
                    fontSize: 14,
                    resize: "vertical",
                    outline: "none",
                    transition: "border-color 0.2s",
                  }}
                  name="suggestion"
                  placeholder="We are listening intently..."
                  required
                />
              </div>
            )}

            {/* CTA Buttons */}
            <div
              style={{
                display: "flex",
                gap: 14,
                justifyContent: "center",
                marginTop: 8,
              }}
            >
              <button
                type="submit"
                disabled={!(feedbackScore && feedbackValue)}
                style={{
                  flex: 1,
                  maxWidth: 200,
                  height: 48,
                  borderRadius: 10,
                  border: "none",
                  background: feedbackScore && feedbackValue ? "#006f92" : "#d0d5dd",
                  color: "#fff",
                  fontFamily: "'Inter', sans-serif",
                  fontWeight: 700,
                  fontSize: 15,
                  cursor: feedbackScore && feedbackValue ? "pointer" : "not-allowed",
                  transition: "all 0.2s",
                  letterSpacing: "0.5px",
                }}
              >
                SUBMIT
              </button>
              <a
                href="#"
                onClick={(e) => handleSkipModalOpen(e)}
                style={{
                  flex: 1,
                  maxWidth: 120,
                  height: 48,
                  borderRadius: 10,
                  border: "1.5px solid #d0d5dd",
                  background: "transparent",
                  color: "#667085",
                  fontFamily: "'Inter', sans-serif",
                  fontWeight: 700,
                  fontSize: 15,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  textDecoration: "none",
                  transition: "all 0.2s",
                }}
              >
                Skip
              </a>
            </div>
          </form>
        </div>
      </div>
      {modalState.congratsModal && (
        <>
          <Modal
            show={modalState.congratsModal}
            id="congratsModal"
            tabIndex={-1}
            dialogClassName="congrats-modal-dialog"
          >
            <Confetti width={"450px"} height={"300px"} numberOfPieces={100} />
            <div>
              <div className="">
                <div className="modal-header">
                  <h5 className="modal-title bigText pr-color">
                    {modalState.isSkipped ? "PUBLISH YOUR PROFILE" : "CONGRATULATIONS"}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={(e) => handleFeedbackModalStat()}
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body pt-0 pb-0">
                  <div className="px-2 text-center">
                    {!modalState.isSkipped && (
                      <>
                        <div className="mudrakoshBox">
                          <p>500 Mudras DEPOSITED</p>
                          <span>
                            <img src={feedbackMudraKosh} alt="#" />
                          </span>
                        </div>
                        <div className="divideWrap">
                          <img src={bgBorder} alt="#" />
                        </div>
                      </>
                    )}
                  </div>
                </div>
                <div className="modal-footer pt-2">
                  <button
                    className="custom_button ms-2"
                    style={{ paddingLeft: "64px", paddingRight: "64px" }}
                    onClick={(e) => handleCongratsModalClose(true)}
                  >
                    YES
                  </button>
                  {!modalState.isSkipped && (
                    <div className="rewardNote">
                      <small>
                        <img src={iIcon} alt="iIcon" />
                        You will be able to check your reward in the “Mudrakosh”
                        section
                      </small>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Modal>
        </>
      )}
      {modalState.congratsPreview && (
        <>
          <Modal
            size="md md-x"
            dialogClassName="modal-dialog-centered md-x"
            show={modalState.congratsPreview}
            className="founder-message success-modal md-x"
            id="successMsg"
            tabIndex={-1}
            keyboard={false}
            backdrop="static"
          >
            <Confetti width={"400px"} height={"300px"} numberOfPieces={100} />
            <Modal.Header className="justify-content-center pb-1 px-0 pt-0">
              <div className="header-before">
                <img src={successCheck} alt="success" />
              </div>
              <Modal.Title className="mt-5">
                <div className="mb-3 pt-4">YOU ARE AWESOME!</div>
              </Modal.Title>
            </Modal.Header>
            <div
              className="text-center label-info color-black"
              dangerouslySetInnerHTML={{
                __html:
                  "You have registered and joined the mission successfully.",
              }}
            />
            <Modal.Footer className="justify-content-center pt-3 d-grid">
              <Button
                handleClick={(e) =>
                  isMobile
                    ? (setMobileAlert(true), handleCongratsPreviewModalClose())
                    : handleRedirectDashboard(e, "/dashboard")
                }
                // handleRedirectDashboard(e, "/dashboard")
                title="Start Your Publishing Journey Now"
                type="button"
              />
              <div className="text-center">
                <Link
                  to="/"
                  onClick={(e) => handleRedirect(e, "/")}
                  className="link text-decoration-none f-700"
                >
                  Home
                </Link>
              </div>
            </Modal.Footer>
          </Modal>
        </>
      )}
      {modalState.skipModal && (
        <Modal
          size="md md-x"
          show={modalState.skipModal}
          id="skipModal"
          tabIndex={-1}
          dialogClassName="modal-dialog-centered skip-modal-lg"
        >
          <Modal.Header>
            <h5 className="modal-title pr-color">
              Earn 500 Mudras (INR) Before You Continue
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={(e) => setModalState(initialState)}
              aria-label="Close"
            />
          </Modal.Header>
          <Modal.Body className="pt-0 pb-2">
            <div className="px-2 text-center">
              <p className="f-16">
                Use Mudras to unlock discounts and benefits across the platform
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <a
              href=""
              className="linkBtn"
              onClick={(e) => {
                e.preventDefault();
                handleSkipModalClose(true);
              }}
              style={{ paddingRight: "30px" }}
            >
              Maybe Later
            </a>
            <button
              type="button"
              className="button button-primary ms-2"
              onClick={(e) => handleSkipModalClose(false)}
            >
              Earn 500 Mudras
            </button>
          </Modal.Footer>
        </Modal>
      )}
      {modalState.referModal && (
        <Modal
          show={modalState.referModal}
          id="referModal"
          tabIndex={-1}
          className="md-x"
        >
          <div>
            <div className="modal-content border-0 referContent">
              <div className="modal-header pb-0">
                <h5 className="modal-title referText">Refer and Earn</h5>
                <p className="bigSubText">Invite 5 friends to register</p>
                <div className="mudraCount">
                  <span>
                    <b>Earn</b>
                    <br />
                    250 Mudras
                  </span>
                  <i>
                    <img src={kalashIcon} alt="#" />
                  </i>
                </div>
                <button
                  type="button"
                  className="btn-close text-white"
                  onClick={(e) => {
                    setModalState(initialState);
                  }}
                  aria-label="Close"
                />
              </div>
              <div className="modal-body pt-0 pb-0">
                <div className="px-2 text-center shareModal">
                  <div className="referStep">
                    <ul>
                      <li>
                        <span>
                          <b className="icon-persons" />
                        </span>
                        Invite 5 friends to register
                      </li>
                      <li>
                        <span>
                          <b className="icon-register" />
                        </span>
                        Your friends register
                      </li>
                      <li>
                        <span>
                          <b className="icon-wallet" />
                        </span>
                        You receive 250 Mudras{" "}
                      </li>
                    </ul>
                  </div>
                  <p className="receiveText">
                    Your friends also receive 250 Mudras each as joining bonus
                    after registration
                  </p>
                  <div className="socialShare">
                    <small>Invite via</small>
                    <ul className="socialRefer">
                      <li>
                        <EmailShareButton
                          separator=" "
                          subject="Your friend has invited you to join Mission Vikramshila"
                          body={title}
                          url=" "
                          shareUrl={title}
                        >
                          <img src={email48} alt="#" />
                        </EmailShareButton>
                      </li>

                      <li>
                        <WhatsappShareButton
                          url={shareUrl}
                          title={title}
                          separator=" "
                          className="Demo__some-network__share-button"
                        >
                          <img src={whatsapp48} alt="#" />
                        </WhatsappShareButton>
                      </li>
                      <li>
                        <TwitterShareButton
                          url={shareUrl}
                          title={title}
                          separator=" "
                          className="Demo__some-network__share-button"
                        >
                          <img src={twitter48} alt="#" />
                        </TwitterShareButton>
                      </li>
                    </ul>
                  </div>
                  <div className="divideLine">
                    <b>or</b>
                  </div>
                  <div className="codeBelow ">
                    <small>Refer using your unique code</small>
                    <div className="codeWrap">
                      <p id="#code" className="pr-color flex-fill">
                        {referralCode || "XXXXXXX"}
                      </p>
                      <p
                        onClick={(e) => handleCodeCopy(e)}
                        className="sr-color"
                      >
                        <b id="code" className="icon-copy sr-color" />
                        &nbsp;&nbsp;Copy Code
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer pt-0 pb-0">
                <a
                  onClick={(e) => handleReferModalClose(false)}
                  className="linkBtn mr-5"
                >
                  I’ll do it later
                </a>
                <button
                  onClick={(e) => handleReferModalClose(true)}
                  className="button button-primary ms-2"
                >
                  Publish Profile
                </button>
                <div className="rewardNoteRefer">
                  <small>
                    <i></i>
                    <p>
                      Receiving 250 Mudras is conditional to 5 friends
                      registering with us
                      <br />
                      You will be able to check your reward in the “Mudrakosh”
                      section
                    </p>
                  </small>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
      <Modal
        show={mobileAlert}
        size="md"
        tabIndex={-1}
        dialogClassName="modal-dialog-centered authorModal"
      >
        <Modal.Header className="modal-header pb-0">
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={(e) => setMobileAlert(false)}
          />
          <Modal.Title className="modal-title pl-0">
            <h2 className="fontsizeshastra ml-4">Note</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pb-0 pt-0">
          <div className="grantDetails pl-2 pr-2 mb-3">
            <div className="writeYourContent pb-0 pt-0">
              <p className="mb-0 text-left">
                <p className="yellowTextWelcome text-center blackColorTestRegst">
                  For a better publishing experience, article submission is
                  currently supported on desktop only. Please log in again from
                  your desktop.
                </p>
              </p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Footer />
    </>
  );
};

export default ThanksForRegistration;
